export default function AboutUs({ contentData, initError, initLoader }) {
  return (
    <>
      <div className="static-content">
        <div className="content-section">
          <h3 className="section-title">About us</h3>
          <div className="content-body">
            <p className="content-paragraph">Bit Aegis Wallet is your premier secure vault for Bitcoin mining distribution, storage, offering seamless deposits and withdrawals via blockchain addresses within 8 hours. Featuring 3-Layer Protection Protocol, Access Key Locker, custom mobile keyboards, no logs, and data erasure, we ensure unbreakable security. Users benefit from privacy, ease, and asset growth potential in evolving crypto landscapes.</p>
          </div>
        </div>
        <div className="content-section">
          <h6 className="subsection-title">We are a highly secured, privacy-focused platform for Bitcoin mining distribution, storage and wallet management</h6>
            <p className="content-paragraph"><strong><b>Bit Aegis Wallet</b></strong></p>
            <p className="content-paragraph">Contact Mail : vexel.cyber.pix@gmail.com</p>
            <p className="content-paragraph">Customer Support : <a style={{ textDecoration: 'none' }} className="nav-item" href="https://t.me/bitaegiswallet" target="_blank" rel="noopener noreferrer"> Click here & Chat with us</a></p>
        </div>
      </div>
    </>
  );
}
